var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoArrowBlueLeftinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.837,
    height: 23.895
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.172 23.411a1.638 1.638 0 000-2.326L5.637 13.55h38.56a1.638 1.638 0 000-3.276H5.67l7.5-7.486a1.633 1.633 0 00-2.31-2.31L.444 10.9a1.442 1.442 0 000 2.08l10.402 10.431a1.638 1.638 0 002.326 0z",
    fill: "#005fe2"
  })));
}

export default SvgCoArrowBlueLeftinline;